export const ChevronLeftIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Previous",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="chevron-left-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <title>{title}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 19l-7-7 7-7"
      />
    </svg>
  );
};
